import React, { useEffect, useState } from "react";
import WhiteArrow from "@/src/images/WhiteArrow.png";
import GreenArrow from "@/src/images/GreenArrow.png";
import S from "./ArrowButton.styled";

type Props = {
  button: {
    mediaItemUrl: string;
  };
  title: string;
  backgroundColor?: string;
  noA?: boolean;
};

const ArrowFile = ({ button, title, backgroundColor, noA }: Props) => {
  const { mediaItemUrl } = button;

  const [color, setColor] = useState("");
  const [arrow, setArrow] = useState();

  useEffect(() => {
    if (!backgroundColor || backgroundColor === "white") {
      setColor("#224C5D");
      setArrow(GreenArrow);
    } else {
      setArrow(WhiteArrow);
      setColor("#f9f9f9");
    }
  }, []);

  if (noA) {
    return (
      <S.NoAContainer color={color}>
        <S.Title color={color}>{title}</S.Title>
        <img src={arrow} alt="arrow" />
      </S.NoAContainer>
    );
  }

  return (
    <S.Container color={color} href={mediaItemUrl} target="_blank">
      <S.Title color={color}>{title}</S.Title>
      <img src={arrow} alt="arrow" />
    </S.Container>
  );
};

export default ArrowFile;
